import { createContext } from 'react';
import { SimplifiedSelectionEntry } from '../../types/Library/LibrarySimplified';

export const LibraryContext = createContext<Map<string, SimplifiedSelectionEntry[] | undefined>>(new Map());